import { useHttpClient } from '@/common/api/httpClient';
import type { ShapeResponse } from './models/shapeResponse';
import type { ShapeRequest } from './models/shapeRequest';
import { processShape } from '../domain/processShape';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { useShapeStore } from 'shared/shapes/stores/shapeStore';

export interface CreateShapeRequest {
  shape: ShapeRequest;
}

export interface CreateShapeResponse {
  ok: true;
  shape: ShapeResponse;
}

export function useCreateShape() {
  const httpClient = useHttpClient();
  const shapeStore = useShapeStore();

  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(action: CreateShapeRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`shape`), {
      headers,
      method: 'POST',
      body: JSON.stringify(action.shape),
    });

    const text = translations.value.shapes.actions.create;

    const response = await httpClient.action<CreateShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const shape = await response.json() as ShapeResponse;
        processShape(shape);
        shapeStore.add(shape);
        return {
          ok: true,
          shape: shape,
        };
      },
    });

    return response;
  }
}
